export const contentTypes = {
    RESOURCE: 'RESOURCE',
    COURSE: 'COURSE'
  };
  